import { Box, Typography, Avatar, IconButton, Menu } from "@mui/material";
import { styles } from "../stylesSidebar";
import { useGetUserByUidQuery } from "@/store/api/userApi";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useNavigate } from "react-router-dom";
import { useGetMySubscriptionQuery } from "@/store/api/premiumApi";
import MoreSvg from "@/assets/svg/MoreSvg";
import { useState, MouseEvent } from "react";
import SidebarBottomMenu from "./SidebarBottomMenu";
import { getOrdinal } from "@/helpers/getOrdinal";

const UserInfo = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleOpenMenu = (mouseEvent: MouseEvent<HTMLElement>) => {
    setAnchorEl(mouseEvent.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const { user: authUser } = useAppSelector((state) => state.auth);
  const { data: user } = useGetUserByUidQuery(authUser?.uid!, {
    skip: !authUser?.uid,
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  useGetMySubscriptionQuery(undefined, {
    skip: !authUser?.uid,
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  const navigate = useNavigate();
  if (!user) return null;

  return (
    <Box sx={styles.userInfoWrapper}>
      <Avatar
        src={user.image?.url || ""}
        alt="avatar"
        sx={{ width: 40, height: 40, objectFit: "cover", cursor: "pointer" }}
        onClick={() => navigate(`/profile/${authUser?.uid}`)}
      />
      <Box
        sx={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          {!!user.earnerRank && (
            <Box sx={styles.badge}>
              <Typography sx={styles.badgeText}>
                <Box component="span" sx={styles.badgeTextRank}>
                  {getOrdinal(user.earnerRank)}{" "}
                </Box>
                best earner
              </Typography>
            </Box>
          )}
          <Typography
            sx={{ ...styles.username, cursor: "pointer" }}
            onClick={() => navigate(`/profile/${authUser?.uid}`)}
          >
            {user.username}
          </Typography>
        </Box>
        <IconButton onClick={handleOpenMenu}>
          <MoreSvg />
        </IconButton>
        <Menu anchorEl={anchorEl} open={isMenuOpen} onClose={handleCloseMenu}>
          <SidebarBottomMenu onItemClick={handleCloseMenu} />
        </Menu>
      </Box>
    </Box>
  );
};

export default UserInfo;
